<template>
  <router-view/>
</template>

<script lang="ts">
import {defineComponent, onMounted, onUnmounted} from 'vue';
import notifier from "@/core/utils/notifier.js";
import {NOTIFY} from "@/constants.js";

export default defineComponent({
  name: 'App',
  setup() {
    // Троттлинг по стабильному id — без него пачка пушей (например, несколько
    // уведомлений о постах в группах подряд) рисует тосты один за другим поверх
    // экрана. Чат и уведомления — разные id, чтобы не глушить друг друга.
    const handleNotificationToast = (event: CustomEvent) => {
      const { title, message, type } = event.detail;
      const text = `${title}\n${message}`;

      if (type === 'info') {
        notifier.info(NOTIFY.pushChatMessage, text, 5000);
      } else {
        notifier.success(NOTIFY.pushNotification, text, 5000);
      }
    };

    onMounted(() => {
      window.addEventListener('show-notification-toast', handleNotificationToast as EventListener);
    });

    onUnmounted(() => {
      window.removeEventListener('show-notification-toast', handleNotificationToast as EventListener);
    });
  }
});
</script>

<style>
</style>